export default {
  DATE: 'DATE',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  WEEK: 'WEEK'
}
